import { useEffect, useState } from 'react';
import {
  Table,
  Loader,
  Center,
  Text,
  Button,
} from '@mantine/core';
import { Page } from '@/components';
import { getMutationResult } from '@/helpers/query';
import { useTranslation } from 'react-i18next';
import { useGetAllUsersMutation } from '@/services/api';
import { useNavigate } from 'react-router-dom';
import routes from '@/routes';
import classes from './style.module.css';

const Users = () => {
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [apiGetAllUsers] = useGetAllUsersMutation();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const { data: result } = await getMutationResult({}, apiGetAllUsers);
        const { success, data: usersData } = result;

        if (success) {
          setData(usersData);
        } else {
          setIsError(true);
        }
      } catch (error) {
        setIsError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  if (isError) {
    return (
      <Center>
        <Text c="red">{t('pages.userlist.noData')} </Text>
      </Center>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Center>
        <Text>{t('pages.userlist.noData')}</Text>
      </Center>
    );
  }

  const onCreateUserClick = () => {
    navigate(routes.settingsCreateUser.path);
  };

  const headers = [t('pages.userlist.headers.role'), t('pages.userlist.headers.email'), t('pages.userlist.headers.status')];

  const userStatus = {
    active: 'פעיל',
    blocked: 'חסום',
  };

  const onEditUserClick = (id) => {
    navigate(`/settings/editUser/${id}`);
  };

  return (
    <Page hideHelp hideNews title={t('pages.userlist.title')}>
      <div className={classes.container}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              {headers.map((header, index) => (
                <Table.Th key={index}>{header}</Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {data.length === 0 ? (
              <Table.Tr>
                <Table.Td colSpan={3} style={{ textAlign: 'center' }}>
                  {t('pages.userlist.noData')}
                </Table.Td>
              </Table.Tr>
            ) : (
              data.map((user) => (
                < Table.Tr key={user._id}>
                  <Table.Td>{user.role.name}</Table.Td>
                  <Table.Td>{user.email}</Table.Td>
                  <Table.Td>{userStatus[user.status]}</Table.Td>
                  <Table.Td>
                    <Button size='xs' onClick={() => onEditUserClick(user._id)}>
                      {t('pages.userlist.editUser')}
                    </Button>
                  </Table.Td>
                </Table.Tr>
              ))
            )}
          </Table.Tbody>
        </Table>

        <div className={classes.buttonsWrapper}>
          <Button loading={loading} onClick={onCreateUserClick}>
            {t('pages.userlist.createUser')}
          </Button>
        </div>
      </div>
    </Page>

  );
};

export default Users;
